const BASE_URL = process.env.REACT_APP_BASE_URL!;
const CAPA_URL = process.env.REACT_APP_CAPA_URL!;
const CONNECT_URL = process.env.REACT_APP_CONNECT_URL!;
const BLOG_URL = process.env.REACT_APP_BLOG_URL!;
const API_URL = process.env.REACT_APP_API_URL;
const IMPStoreCode = process.env.REACT_APP_IAMPORT_STORE_CODE;
const IMPWebhookUrl = process.env.REACT_APP_IAMPROT_WEBHOOK_URL;

export const authConfig = {
  apiURL: API_URL,
  clientID: process.env.REACT_APP_CLIENT_ID,
  clientSecret: process.env.REACT_APP_CLIENT_SECRET,
  accessTokenKey: process.env.REACT_APP_CLIENT_ACCESS_TOKEN,
  refreshTokenKey: process.env.REACT_APP_CLIENT_REFRESH_TOKEN,
  userInfo: process.env.REACT_APP_CLIENT_USER_INFO
};

export {
  BASE_URL,
  IMPStoreCode,
  IMPWebhookUrl,
  CAPA_URL,
  CONNECT_URL,
  BLOG_URL
};
